export default "__VITE_ASSET__BB7w$Ii5__"